import { StylesConfig } from 'react-select'

export const getExpirySelectStyles = (): StylesConfig => ({
  placeholder: base => ({
    ...base,
    color: 'var(--color-grey-06)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }),
  input: base => ({
    ...base,
    color: 'var(--color-grey-10)',
  }),
  control: base => ({
    ...base,
    boxShadow: 'none !important',
    height: '30px !important',
    '&:hover': {
      boxShadow: 'none !important',
    },
  }),
  menu: base => ({
    ...base,
    marginTop: '1px !important',
  }),
  option: (base, state) => ({
    ...base,
    height: '40px',
    padding: '8px 16px',
    backgroundColor: state.isSelected ? 'var(--colour-secondary-50)' : base.backgroundColor,
    color: 'var(--colour-text-900)',
    '&:hover': {
      backgroundColor: state.isSelected ? 'var(--colour-secondary-50)' : 'var(--color-grey-04)',
      color: 'var(--colour-text-900)',
    },
  }),
})
